<template>
<!-- 听书最近更新 -->
    <div class="main">
        <div class="margin-box paddingH16">
            <div class="recent-changes">
                <!-- 标题 -->
                <div class="title">
                    <h3>
                        <strong class="bold">
                            最近更新
                        </strong>
                        <img class="marginL4" width="10" height="14" src="icon/learnIcon/bar-code.png" alt="条形图图标">

                    </h3>
                    <div class="title-desc">
                        精选行业最新干货，快速获取最精内容
                    </div>
                    <!-- <div class="play-path">
                        <a class="inlineBlock" @click="playAll()">
                            <img class="colorPlay-icon" src="icon/learnIcon/coloured-play.svg" alt="有色播放图标">
                            <span>播放全部</span>
                        </a>

                    </div> -->
                </div>
                <!-- 播放列表内容 -->
                <div class="content">
                   <ul class="content-list">
                       <li class="list-style" v-for="(item , index) in dataList.slice(0,4)" :key="index"
                            @click="viewItem(item)">
                           <img style="width:16px;height:16px;margin-top:2px;margin-left:8px;" src="icon/learnIcon/play.png" alt="播放图标">
                           <span class="explain">{{item.title}}</span>
                           <span class="time">{{formatTime(item.duration)}}</span>
                       </li>
                   </ul>
                </div>
                <!-- 查看更多 -->
                <!-- <div class="see-more">
                    <span>查看更多</span>
                    <img src="icon/learnIcon/more.svg" alt="查看更多图标">
                </div> -->

            </div>
        </div>

    </div>
</template>
<script>

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// util
import appHelper from '@util/appHelper';

const config = {
    apiConfig : {
        list : {
            url : 'portal/api/audio/latest',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages'
        }
    }
};

export default {

    extends : shixunPagePart,
    data(){
        return {
            name: "recentChanges",
            enableDataList : true,
            autoLoadDataList : true,
            scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,
        }
    },
     components: {
    },


    methods:{
        formatTime(time){
            let minute =  parseInt(time/60);
            let second = time%60;
            let strMinute,strSecond;

            if(minute < 10){
               strMinute = '0'+minute;
            }else{
                strMinute = minute;
            }
            if(second < 10){
               strSecond = '0'+second;
            }else{
                strSecond = second;
            }
            return strMinute+':'+strSecond
        },
        viewItem(dataItem) {
            appHelper.redirect('/voiceCourse/detail/' + dataItem.id);
        },
        playAll() {
            window.tempVoiceList = this.dataList;
            appHelper.redirect('/voiceCourse/detail/');
        }
    },
    mounted(){
    }
}
</script>
<style scoped lang="scss">

    //div,ul,li,input {
    //    margin: 0;
    //    padding: 0;
    //}

    .main{
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .margin-box{
        background: #fff;
    }
    .recent-changes{
        // width: 95%;
        //width: 100%;
        // margin: 0 auto;
        //padding: 0 18px;
        box-sizing: border-box;
        padding-bottom: 24px;
    }

    // 标题播放器
    .title{
        position: relative;
        width: 102%;
        overflow: hidden;
        h3{
            // position: absolute;
            // top: 0;
            // left: 0;

            // width: 72px;
            height: 25px;
            margin-top: 16px;
            margin-bottom: 12px;

            font-size: 18px;

            font-weight: 500;
            // line-height: 31px;
            color: #34353C;



        }

         .title-desc{

                font-size: 13px;

                font-weight: 400;
                line-height: 23px;
                color: #717380;
                opacity: 0.8;
                margin-bottom: 16px;
            }

        .play-path{
            position: absolute;
            top: 8px;
            right: 7px;
            width: 115px;
            height: 40px;
            border-radius: 20px;
            background: linear-gradient(to right, #fe6b49, #ff4559);
            box-shadow: 4px 4px 10px #ffc3cb;
            .colorPlay-icon{
                position: absolute;
                top: 7px;
                left: 4px;
                width: 25px;
                height: 25px;
            }
            span{
                position: absolute;
                top: 8px;
                right: 10px;
                color:#fff;
                font-weight: 500;
            }
        }
    }

    // 播放列表
    .content{
        width: 100%;
        .content-list{

            background: rgba($color: #DFEBF7, $alpha: 0.39);
            border-radius: 8px;
            padding: 17px 0 1px 0;
            // padding-bottom: 0;
        }



        .list-style{
            list-style: none;
            // margin-bottom: 20px;
            margin-bottom: 15px;
            //height: 30px;
            line-height: 18px;
            display: flex;
            img{
                margin-right: 10px;
                // vertical-align: middle;
                height: 30px;
                width: 23px;
            }
            .explain{


                font-size: 14px;

                font-weight: 400;
                // line-height: 18px;
                color: #2C2C2C;

                flex: 1;
                white-space:nowrap;
                overflow:hidden;
                text-overflow:ellipsis;
            }
            .time{
                margin-right: 10px;
                // width: 30px;
                // height: 14px;

                font-size: 11px;

                font-weight: 400;
                // line-height: 18px;
                color: #8994A9;

                margin-left: 20px;
            }

        }
    }

    // 查看更多
    .see-more{
        text-align: center;
        span{
            color: #999999;
            font-size: 14px;
        }
        img{
            width: 11px;
            height: 10px;
            font-size: 20px;

        }
    }

</style>
